import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import { AiAddQuestionChangeStrategy } from './add-question-ai-change.strategy';
import { AiDeleteQuestionChangeStrategy } from './delete-question-ai-change.strategy';
import { AiUpdateQuestionChangeStrategy } from './update-question-ai-change.strategy';
import { AiChangeType } from '../../../../../../ai';
export var QuestionAiChangeStrategyFactory = /*#__PURE__*/function () {
  function QuestionAiChangeStrategyFactory() {
    _classCallCheck(this, QuestionAiChangeStrategyFactory);
  }

  _createClass(QuestionAiChangeStrategyFactory, null, [{
    key: "create",
    value: function create(context) {
      switch (context.changeType) {
        case AiChangeType.Add:
          return new AiAddQuestionChangeStrategy(context);

        case AiChangeType.Update:
          return new AiUpdateQuestionChangeStrategy(context);

        case AiChangeType.Delete:
          return new AiDeleteQuestionChangeStrategy(context);

        default:
          throw new Error('Unsupported change type');
      }
    }
  }]);

  return QuestionAiChangeStrategyFactory;
}();